import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { CardsApi, RequestStrategyEnum, type WithSignal, type CardResponse, type CardsRequest } from '@shared/api';

const getCardsEffect = createEffect(({ signal, ...request }: WithSignal<CardsRequest> = {}) => CardsApi.getCards(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<CardResponse[]>([])
  .on(getCardsEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getCardsEffect.pending, (_, data) => data)
  .on(getCardsEffect.fail, () => false)
  .on(getCardsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCardsEffect, () => null)
  // .on(getCardsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCardsEffect.fail, () => 'Something went wrong while fetching Cards. Please try again.')
  .on(getCardsEffect.done, () => null)
  .reset(clearEvent);

export const $initialCardsStore = {
  events: {
    getCards: ApiUtilsV2.wrapperApi(getCardsEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
